var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useAccountBadgeStorage } from '../../../../ui/features/form/hooks/useAccountBadgeStorage';
import { getFilterForBulkAction } from '../../../../ui/util/getFilterForBulkAction';
import { accountEntityName } from '@juvare/contact-management/backend/features/accounts/shared';
import React from 'react';
export function useGetAccountsToNotify(params) {
    const { accountBadgeSelectedIds, appliedStorageFilters } = params;
    const accountBadgeStorage = useAccountBadgeStorage();
    const getAccountsToNotify = React.useCallback(() => __awaiter(this, void 0, void 0, function* () {
        const filter = getFilterForBulkAction(accountBadgeSelectedIds, appliedStorageFilters);
        const accountBadges = yield accountBadgeStorage.list({
            filter: [
                ...filter,
                { column: 'distributionStatus', op: '=', value: 'printed' },
                {
                    column: 'accountId',
                    op: 'in',
                    subFilter: {
                        entity: accountEntityName,
                        filter: [
                            {
                                column: 'systemStatus',
                                op: '=',
                                value: 'active',
                            },
                        ],
                    },
                },
            ],
        });
        const accountsToNotify = { accountToNotifyIds: [], accountBadgeToNotifyIds: [] };
        accountBadges.rows.forEach((row) => {
            accountsToNotify.accountToNotifyIds.push(row.columns.accountId);
            accountsToNotify.accountBadgeToNotifyIds.push(row.id);
        });
        return accountsToNotify;
    }), [accountBadgeSelectedIds, appliedStorageFilters, accountBadgeStorage]);
    return { getAccountsToNotify };
}
